/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import _ from "lodash";
import axios from "../../../api/axiosService";
import linkIcon from "../../../assets/icon/linkIcon.svg";

export default function Project({ ...props }) {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState({});

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `/api/radarSingle/list?artistId=${props.id}`,
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Xử lý lỗi tại đây
    }
  };

  useEffect(() => {
    if (props.id) fetchData();
  }, []);

  return (
    <div className="project-tab">
      {_.isObject(data) && (
        <div className="content">
          <div className="project-list">
            {data?.length > 0 &&
              data.map((value) => (
                <div
                  key={value.id}
                  className="project-item flex flex-col justify-between"
                >
                  <div>
                    <img
                      src={_.get(value, "image", "")}
                      alt={_.get(value, "image")}
                    />
                    <div className="title title-2">{value.title}</div>
                  </div>
                  <div className="action normal-text w-full">
                    <a
                      className="w-1/2 max-sm:w-full"
                      href={value.youtubeUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{ flex: 1 }} // ← changed
                    >
                      <button
                        className="youtube-btn"
                        style={{ width: "100%" }} // ← always 100%
                      >
                        YouTube
                      </button>
                    </a>

                    {value.spotifyUrl && (
                      <a
                        className="w-1/2 max-sm:w-full"
                        href={value.spotifyUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className="spotify-btn w-full -ml-px">
                          Digital Audio
                        </button>
                      </a>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

// const DATA = [
//   {
//     id: "61ab39bdd4607e001d53bd2f",
//     title: "asdfasdfs",
//     image: "https://i.ytimg.com/vi/jgZkrA8E5do/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDZdVKrDz4thTBjXcD3TT4JmZSwVA",
//     youtube: "https://www.youtube.com/watch?v=jgZkrA8E5do&ab_channel=BinzDaPoet",
//     spotify: "https://open.spotify.com/track/1lcBt7LoEikqYmhUoa2cez"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd4f",
//     title: "asdfasdfs",
//     image: "https://i.ytimg.com/vi/jgZkrA8E5do/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDZdVKrDz4thTBjXcD3TT4JmZSwVA",
//     youtube: "https://www.youtube.com/watch?v=jgZkrA8E5do&ab_channel=BinzDaPoet",
//     spotify: "https://open.spotify.com/track/1lcBt7LoEikqYmhUoa2cez"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd3f",
//     title: "asdfasdfs",
//     image: "https://i.ytimg.com/vi/jgZkrA8E5do/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDZdVKrDz4thTBjXcD3TT4JmZSwVA",
//     youtube: "https://www.youtube.com/watch?v=jgZkrA8E5do&ab_channel=BinzDaPoet",
//     spotify: "https://open.spotify.com/track/1lcBt7LoEikqYmhUoa2cez"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd1f",
//     title: "asdfasdfs",
//     image: "https://i.ytimg.com/vi/jgZkrA8E5do/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDZdVKrDz4thTBjXcD3TT4JmZSwVA",
//     youtube: "https://www.youtube.com/watch?v=jgZkrA8E5do&ab_channel=BinzDaPoet",
//     spotify: "https://open.spotify.com/track/1lcBt7LoEikqYmhUoa2cez"
//   },
// ];
